import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '../../forms/button/button.module';
import { StandbyMessageComponent } from './standby-message.component';

@NgModule({
  declarations: [StandbyMessageComponent],
  imports: [CommonModule, ButtonModule],
  exports: [StandbyMessageComponent]
})
export class StandbyMessagesModule {}
